export var AfriexRatePromoCode;
(function (AfriexRatePromoCode) {
    AfriexRatePromoCode["NewUser"] = "NEW_USER";
    AfriexRatePromoCode["RegularUser"] = "REGULAR_USER";
    AfriexRatePromoCode["ChurnedUser"] = "CHURNED_USER";
    AfriexRatePromoCode["PowerUser"] = "POWER_USER";
    AfriexRatePromoCode["InactiveUser"] = "INACTIVE_USER";
    AfriexRatePromoCode["RegulatedDebit"] = "REGULATED_DEBIT";
    AfriexRatePromoCode["UnregulatedDebit"] = "UNREGULATED_DEBIT";
    AfriexRatePromoCode["Loyalists"] = "LOYALISTS";
    AfriexRatePromoCode["ACHBank"] = "ACH_BANK";
})(AfriexRatePromoCode || (AfriexRatePromoCode = {}));
export var AfriexPromoField;
(function (AfriexPromoField) {
    AfriexPromoField["FromCurrency"] = "FROM_CURRENCY";
    AfriexPromoField["ToCurrency"] = "TO_CURRENCY";
    AfriexPromoField["FromCountry"] = "FROM_COUNTRY";
    AfriexPromoField["ToCountry"] = "TO_COUNTRY";
    AfriexPromoField["FromAmount"] = "FROM_AMOUNT";
    AfriexPromoField["ToAmount"] = "TO_AMOUNT";
    AfriexPromoField["FromChannel"] = "FROM_CHANNEL";
    AfriexPromoField["ToChannel"] = "TO_CHANNEL";
    AfriexPromoField["TransactionType"] = "TRANSACTION_TYPE";
    AfriexPromoField["TransactionDate"] = "TRANSACTION_DATE";
    AfriexPromoField["TransactionCount"] = "TRANSACTION_COUNT";
    AfriexPromoField["TransactionVolume"] = "TRANSACTION_VOLUME";
    AfriexPromoField["UserId"] = "USERID";
    AfriexPromoField["BusinessId"] = "BUSINESSID";
    AfriexPromoField["Group"] = "GROUP";
    AfriexPromoField["WalletTag"] = "WALLET_TAG";
})(AfriexPromoField || (AfriexPromoField = {}));
export var AfriexPromoComparator;
(function (AfriexPromoComparator) {
    AfriexPromoComparator["Equals"] = "EQUALS";
    AfriexPromoComparator["LessThan"] = "LESS_THAN";
    AfriexPromoComparator["GreaterThan"] = "GREATER_THAN";
    AfriexPromoComparator["Between"] = "BETWEEN";
    AfriexPromoComparator["NotEquals"] = "NOT_EQUALS";
})(AfriexPromoComparator || (AfriexPromoComparator = {}));
//# sourceMappingURL=AfriexRatePromo.js.map